import React from 'react';
import MSLogoImage from './media-shuttle-logo.svg';
import MALogoImage from './manager-agents-logo.svg';
import JetLogoImage from './jet-logo.svg';
import FlightLogoImage from './flight-logo.svg';

const config = {
    jet: {
        image: JetLogoImage,
        to: '/jet/',
        productName: 'Jet',
        description: 'Learn how to set up Jet to automate system-to-system content exchange between global locations.',
    },
    'media-shuttle': {
        image: MSLogoImage,
        to: '/media-shuttle/',
        productName: 'Media Shuttle',
        description:
            'Learn about deploying, managing and using Media Shuttle portals for person-initiated file transfers.',
    },
    flight: {
        image: FlightLogoImage,
        to: '/flight/',
        productName: 'Flight',
        description: 'Learn how Flight accelerates large datasets to and from the cloud.',
    },
    manager: {
        image: MALogoImage,
        to: '/manager-agents/',
        productName: 'Manager+Agents',
        description:
            'Browse documentation on Manager+Agents, used by top media enterprises to automate global workflows.',
    },
};

const withConfiguration = (WrappedComponent, product) => {
    return class extends React.Component {
        constructor(props) {
            super(props);
        }
        render() {
            return <WrappedComponent {...config[product]} />;
        }
    };
};

export default withConfiguration;
